import MaterialListGroup from './material-group';
import Feeds from './tf-materials/feeds';
import Launch from './tf-materials/launch';
import Material from './tf-materials/material';

export default [
  {
    path: '/product',
    title: '商品组',
    component: () => <MaterialListGroup type={1} />,
  },
  {
    path: '/advert',
    title: '广告组',
    component: () => <MaterialListGroup type={2} />,
  },
  {
    title: '智能feeds',
    path: '/feeds',
    component: Feeds,
    getLink({ search = '' }) {
      return `feeds${search}#/feeds-flow`;
    },
  },
  {
    title: '导购魔方',
    path: '/magic',
    component: () => <Launch />,
    getLink({ path, search = '' }) {
      return `${path}${search}#/guiding-box`;
    },
  },
  {
    title: '优惠券池',
    path: '/coupon',
    component: () => <Launch />,
    getLink({ path, search = '' }) {
      return `${path}${search}#/coupon-pool`;
    },
  },
];
